var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.625,
    height: 25.391,
    viewBox: "0 0 33.625 25.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2850",
    transform: "translate(-478.929 -42.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2845",
    "data-name": "Group 2845",
    transform: "translate(307.119 -297.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M7.594,27.134H3.2a3.2,3.2,0,1,1,0-6.4H7.76A7.321,7.321,0,0,0,15,15.174,7.179,7.179,0,0,0,8,6.4H3.2A3.2,3.2,0,1,1,3.2,0H8a13.572,13.572,0,0,1,13.42,15.584A13.834,13.834,0,0,1,7.594,27.147Z",
    transform: "translate(171.81 361.344) rotate(-90)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 4.487,
    height: 4.62,
    rx: 2.244,
    transform: "translate(183.073 361.344) rotate(-90)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2846",
    "data-name": "Group 2846",
    transform: "translate(268.553 -302)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(231 357)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M3.545,1.137,5.106,2.7l-3.39,3.39L.324,6.242A.293.293,0,0,1,0,5.919L.156,4.526,3.545,1.137ZM6.071.905,5.338.172a.586.586,0,0,0-.828,0l-.69.69L5.382,2.423l.69-.69a.586.586,0,0,0,0-.828Z",
    transform: "translate(234.379 360.378)",
    fill: "#f5f5f5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.9dcb978554c02461e0665df918a78874.svg";
export { ForwardRef as ReactComponent };